import { Action } from '@ngrx/store';

export enum ProjectOverviewActionTypes {
  Load = '[Project Overview] Load',
  LoadSuccess = '[Project Overview] Load Success',
  LoadFailure = '[Project Overview] Load Failure',
  ClearError = '[Project Overview] Clear Error',
  // New flow: systems list + per-system loading
  LoadSystems = '[Project Overview] Load Systems',
  LoadSystemsSuccess = '[Project Overview] Load Systems Success',
  LoadSystemsFailure = '[Project Overview] Load Systems Failure',
  LoadSystemOverview = '[Project Overview] Load System Overview',
  LoadSystemOverviewSuccess = '[Project Overview] Load System Overview Success',
  LoadSystemOverviewFailure = '[Project Overview] Load System Overview Failure',
}

export class ProjectOverviewLoad implements Action {
  readonly type = ProjectOverviewActionTypes.Load;
}

export class ProjectOverviewLoadSuccess implements Action {
  readonly type = ProjectOverviewActionTypes.LoadSuccess;
  constructor(public payload: any[]) {}
}

export class ProjectOverviewLoadFailure implements Action {
  readonly type = ProjectOverviewActionTypes.LoadFailure;
  constructor(public errorMessage: string) {}
}

export class ProjectOverviewClearError implements Action {
  readonly type = ProjectOverviewActionTypes.ClearError;
}

// --- New actions for system-based loading ---

export interface OverviewSystemDto {
  id: number;
  systemNumber: string;
  checkSheetCount: number;
}

export class ProjectOverviewLoadSystems implements Action {
  readonly type = ProjectOverviewActionTypes.LoadSystems;
}

export class ProjectOverviewLoadSystemsSuccess implements Action {
  readonly type = ProjectOverviewActionTypes.LoadSystemsSuccess;
  constructor(public payload: OverviewSystemDto[]) {}
}

export class ProjectOverviewLoadSystemsFailure implements Action {
  readonly type = ProjectOverviewActionTypes.LoadSystemsFailure;
  constructor(public errorMessage: string) {}
}

export class ProjectOverviewLoadSystemOverview implements Action {
  readonly type = ProjectOverviewActionTypes.LoadSystemOverview;
  constructor(public system: OverviewSystemDto) {}
}

export class ProjectOverviewLoadSystemOverviewSuccess implements Action {
  readonly type = ProjectOverviewActionTypes.LoadSystemOverviewSuccess;
  constructor(
    public systemId: number,
    public payload: any[],
  ) {}
}

export class ProjectOverviewLoadSystemOverviewFailure implements Action {
  readonly type = ProjectOverviewActionTypes.LoadSystemOverviewFailure;
  constructor(
    public systemId: number,
    public errorMessage: string,
  ) {}
}

export type ProjectOverviewActions =
  | ProjectOverviewLoad
  | ProjectOverviewLoadSuccess
  | ProjectOverviewLoadFailure
  | ProjectOverviewClearError
  | ProjectOverviewLoadSystems
  | ProjectOverviewLoadSystemsSuccess
  | ProjectOverviewLoadSystemsFailure
  | ProjectOverviewLoadSystemOverview
  | ProjectOverviewLoadSystemOverviewSuccess
  | ProjectOverviewLoadSystemOverviewFailure;
